import React from 'react';
import PropTypes from 'prop-types';
import { Header } from 'semantic-ui-react';
import PatientInformation from '../../components/EnrollForm/PatientInformation';
import Breadcrumbs from '../../components/Breadcrumbs';

const SignUp = (props) => {
  let treatment = '';
  let gtmTrackId = '';
  switch (props.environment) {
    case 'alunbrig':
      treatment = <span>ALUNBRIG&reg; (brigatinib)</span>;
      gtmTrackId = 'track-79 gtm-track-53';
      break;
    case 'fruzaqla':
      treatment = <span>FRUZAQLA<sup>&trade;</sup> (fruquintinib)</span>;
      gtmTrackId = 'track-79 gtm-track-53';
      break;
    case 'iclusig':
      treatment = <span>ICLUSIG&reg; (ponatinib)</span>;
      gtmTrackId = 'track-79 gtm-track-54';
      break;
    case 'ninlaro':
      treatment = <span>NINLARO&reg; (ixazomib)</span>;
      gtmTrackId = 'track-79 gtm-track-55';
      break;
    case 'mimrylo':
      treatment = <span>Mimrylo (rusfertide)</span>;
      gtmTrackId = 'track-79 gtm-track-55';
      break;
    default:
      treatment = '';
  }
  return (
    <div className="sign-up full-width">
      <Breadcrumbs activeIndex={ 1 } />
      <div className="wrapper">
        <Header as="h1">
          Now take a moment to fill out your personal information
        </Header>

        <PatientInformation
          treatment={ treatment }
          onSubmit={ props.onSubmit }
          environment={ props.environment }
          formType={ props.formType }
          submitTrackId = { gtmTrackId }
        />
      </div>
    </div>
  );
};

SignUp.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  environment: PropTypes.string.isRequired,
  formType: PropTypes.string.isRequired,
};

export default SignUp;
